import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft, BookOpen, Mail, Phone, Building, Scale } from 'lucide-react';

export const Impressum = () => {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1.5rem' }} data-testid="impressum-page">
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: '#2563eb', textDecoration: 'none', fontWeight: 600, marginBottom: '1.5rem' }}>
        <ArrowLeft size={18} /> {t('common.back')}
      </Link>

      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '2rem' }}>
        <BookOpen size={28} style={{ color: '#2563eb' }} />
        <h1 style={{ fontSize: '1.75rem', fontWeight: 800, margin: 0 }}>{t('impressum.title')}</h1>
      </div>

      <div style={{ display: 'grid', gap: '1.5rem' }}>
        {/* Company Info */}
        <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '1.5rem', border: '1px solid #e2e8f0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
            <Building size={20} style={{ color: '#2563eb' }} />
            <h2 style={{ fontSize: '1.1rem', fontWeight: 700, margin: 0 }}>{t('impressum.companyInfo')}</h2>
          </div>
          <p style={{ fontWeight: 700, fontSize: '1.05rem', margin: '0 0 0.25rem' }}>{t('impressum.companyName')}</p>
          <p style={{ color: '#475569', margin: 0 }}>{t('impressum.address')}</p>
        </div>

        {/* Contact */}
        <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '1.5rem', border: '1px solid #e2e8f0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
            <Mail size={20} style={{ color: '#2563eb' }} />
            <h2 style={{ fontSize: '1.1rem', fontWeight: 700, margin: 0 }}>{t('impressum.contact')}</h2>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Mail size={16} style={{ color: '#64748b' }} />
              <span style={{ color: '#475569' }}>{t('impressum.email')}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Phone size={16} style={{ color: '#64748b' }} />
              <span style={{ color: '#475569' }}>{t('impressum.phone')}</span>
            </div>
          </div>
        </div>

        {/* Managing Director */}
        <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '1.5rem', border: '1px solid #e2e8f0' }}>
          <h2 style={{ fontSize: '1.1rem', fontWeight: 700, margin: '0 0 0.5rem' }}>{t('impressum.managingDirector')}</h2>
          <p style={{ color: '#475569', margin: 0 }}>{t('impressum.directorName')}</p>
        </div>

        {/* Registration */}
        <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '1.5rem', border: '1px solid #e2e8f0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
            <Scale size={20} style={{ color: '#2563eb' }} />
            <h2 style={{ fontSize: '1.1rem', fontWeight: 700, margin: 0 }}>{t('impressum.registration')}</h2>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', color: '#475569' }}>
            <p style={{ margin: 0 }}>{t('impressum.court')}</p>
            <p style={{ margin: 0 }}>{t('impressum.regNumber')}</p>
            <p style={{ margin: 0 }}>{t('impressum.vatId')}</p>
          </div>
        </div>

        {/* Disclaimer */}
        <div style={{ background: '#fffbeb', borderRadius: '12px', padding: '1.5rem', border: '1px solid #fde68a' }}>
          <h2 style={{ fontSize: '1.1rem', fontWeight: 700, margin: '0 0 0.5rem', color: '#92400e' }}>{t('impressum.disclaimer')}</h2>
          <p style={{ color: '#78350f', margin: 0, lineHeight: 1.7 }}>{t('impressum.disclaimerText')}</p>
        </div>
      </div>
    </div>
  );
};
